export const PACKAGE_VERSION = '1.8.19';
//# sourceMappingURL=constants.js.map